import { Environment } from 'src/environment';
import { appConfigFactory } from '../factories/appConfig.factory';

export function isPreprod(): boolean {
  const appConfig = appConfigFactory();

  return appConfig.environment === Environment.PREPROD;
}

export function isProd(): boolean {
  const appConfig = appConfigFactory();

  return appConfig.environment === Environment.PROD;
}

export function isDev(): boolean {
  const appConfig = appConfigFactory();

  return appConfig.environment === Environment.DEVELOPMENT;
}

export function isRC(): boolean {
  const appConfig = appConfigFactory();

  return appConfig.environment === Environment.RC;
}
